<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const data = computed(() => contentAttributes.value?.data || {});
const cards = computed(() => data.value.cards || []);
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="evolution-carousel">
    <div class="flex flex-col gap-2">
      <p v-if="data.body" class="mb-0">{{ data.body }}</p>
      <div class="flex gap-2 overflow-x-auto -mx-1 px-1">
        <div
          v-for="(card, index) in cards"
          :key="index"
          class="flex flex-col gap-1 shrink-0 w-48 rounded-lg bg-n-alpha-1 overflow-hidden"
        >
          <img
            v-if="card.header?.imageUrl"
            :src="card.header.imageUrl"
            class="w-full h-24 object-cover"
          />
          <div class="flex flex-col gap-1 p-2">
            <p v-if="card.header?.title" class="font-medium mb-0 text-sm">
              {{ card.header.title }}
            </p>
            <p v-if="card.body?.text" class="mb-0 text-sm">
              {{ card.body.text }}
            </p>
          </div>
        </div>
      </div>
      <p v-if="data.footer" class="text-xs opacity-70 mb-0">
        {{ data.footer }}
      </p>
    </div>
  </BaseBubble>
</template>
